import 'css-chunksrc/client/pages/projectPage/synthesisPage/strategicAxisTag/styles.scss';export default {
  "tag": "_tag_3fpjh_1"
};